<script>
import { mapState, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
import { id } from "vuejs-datepicker/dist/locale";
import APIService from "@/services/api.service";
import axios from "axios";
import config from "@/data/config";
import { SweetModal } from "sweet-modal-vue";

export default {
	name: "jumlahBaptis",
	components: { Datepicker, SweetModal },
	data() {
		return {
			myData: [],
			kriteria: {},
			jk: {},
			lingkunganStasi_: [],
			loading: true,
			formData: { tahun: new Date(), lingkungan_stasi: "Semua data" },
			filterDateLang: id,
			currentPage: 1,
			totalPages: 0,
			PDFloading: false,
			frameLoading: false,
			baseURL: config.baseURL,
			windowHeight: window.innerHeight - 250,
			fileURL: "",
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
	},
	created() {},
	mounted() {
		this.findAll();
		this.lingkunganStasi_ = [...this.lingkunganStasi];
		this.lingkunganStasi_.unshift("Semua data");
	},
	watch: {
		PDFloading: function (val) {
			if (val) {
				this.$swal({ text: "Loading", allowOutsideClick: false });
				this.$swal.showLoading();
			} else {
				this.$swal.close();
			}
		},
	},

	methods: {
		...mapActions({
			getJumlahBaptis: "laporan/getJumlahBaptis",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		async findAll() {
         var d = new Date(this.formData.tahun);
			const filterDateValue = this.$moment(d).format("YYYY-MM-DD");
			this.formData.tahun = filterDateValue.slice(0, 4);
         
			await this.getJumlahBaptis(this.formData).then((response) => {
				this.kriteria = response.kriteria;
				this.jk = response.jk;
				this.myData = response.items;
				console.log(response);
			});
		},
		refreshData() {
			this.findAll();
		},
		onChangeJenis() {
			this.findAll();
		},
		showPDFKK() {
			this.PDFloading = true;
			this.frameLoading = true;
			this.fileURL = this.baseURL + "assets/_blank.pdf";
			axios
				.post(APIService.getPDFLaporanBaptis(), this.formData, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.fileURL =
							this.baseURL + "pdf/" + response.data.filename + ".pdf";
						this.$refs.modalfile.open();
						this.PDFloading = false;
					},
					() => {
						this.PDFloading = false;
					}
				);
		},
		load() {
			this.frameLoading = false;
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Laporan Jumlah Baptis" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="showPDFKK()"
										v-b-tooltip.hover
										title="PDF"
										><i class="fa fa-file-pdf-o"></i
									></b-button>
									<b-button
										v-b-toggle.collapse-filter
										variant="primary"
										size="sm"
										v-b-tooltip.hover
										title="Filter"
										><i class="fa fa-filter"></i
									></b-button>
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh"
									>
										<div
											v-show="isLoading"
											class="
												spinner-border spinner-border-sm
												text-light
											"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<!-- --------------------------- /FILTER --------------------------- -->

				<b-collapse id="collapse-filter" class="mt-2">
					<div class="card-body pb-1 pt-1">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label>Tahun baptis</label>
									<datepicker
										v-model="formData.tahun"
										input-class="datepicker-here form-control form-control-sm"
										:minimumView="'year'"
										:maximumView="'year'"
										format="yyyy"
										:language="filterDateLang"
										@input="onChangeJenis($event)"
										required
									></datepicker>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label>Lingkungan/Stasi Umat</label>
									<b-form-select
										name="lingkungan_stasi"
										v-model="formData.lingkungan_stasi"
										:options="lingkunganStasi_"
										@input="onChangeJenis($event)"
										size="sm"
									></b-form-select>
								</div>
							</div>
						</div>
						<hr />
					</div>
				</b-collapse>

				<div class="card-body">
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<div class="row">
							<div class="col-md-6">
								<div class="table-responsive invoice-table">
									<table class="table table-bordered table-striped">
										<thead class="thead-light">
											<tr>
												<th class="text-left">TAHUN</th>
												<th class="text-right">JUMLAH</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Dibawah 1 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria1 }}
												</td>
											</tr>
											<tr>
												<td>1 - 7 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria2 }}
												</td>
											</tr>
											<tr>
												<td>7 - 21 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria3 }}
												</td>
											</tr>
											<tr>
												<td>Diatas 21 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria4 }}
												</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td>TOTAL</td>
												<td class="text-right">
													{{
														kriteria.kriteria1 +
														kriteria.kriteria2 +
														kriteria.kriteria3 +
														kriteria.kriteria4
													}}
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
							<div class="col-md-6">
								<div class="table-responsive invoice-table">
									<table class="table table-bordered table-striped">
										<thead class="thead-light">
											<tr>
												<th class="text-left">Jenis Kelamin</th>
												<th class="text-right">JUMLAH</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Laki-laki</td>
												<td class="text-right">
													{{ jk.l }}
												</td>
											</tr>
											<tr>
												<td>Perempuan</td>
												<td class="text-right">
													{{ jk.p }}
												</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td>TOTAL</td>
												<td class="text-right">
													{{ jk.p + jk.l }}
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
						</div>

						<hr />

						<v-table
							class="
								table
								b-table
								table-vcenter table-striped table-bordered table-hover
							"
							:data="myData"
							:currentPage.sync="currentPage"
							:pageSize="50"
							@totalPagesChanged="totalPages = $event"
						>
							<thead slot="head" class="thead-light">
								<v-th sortKey="id" defaultSort="asc" class="text-center"
									>No.</v-th
								>
								<th>No Buku LB</th>
								<th>No LB</th>
								<th>Nama</th>
								<th>Nama Baptis</th>
								<th class="text-center">L/P</th>
								<th>Tanggal Lahir</th>
								<th>Tanggal Baptis</th>
								<th class="text-center">Umur saat Baptis</th>
								<th>Imam Pembaptis</th>
							</thead>
							<tbody slot="body" slot-scope="{ displayData }">
								<tr v-for="item in displayData" :key="item.id">
									<td class="text-center">{{ item.id }}</td>
									<td>{{ item.no_buku }}</td>
									<td>{{ item.no_lb }}</td>
									<td>{{ item.nama }}</td>
									<td>{{ item.nama_baptis }}</td>
									<td class="text-center">{{ item.jk }}</td>
									<td>{{ item.tgl_lahir }}</td>
									<td>{{ item.tanggal_human }}</td>
									<td class="text-center">{{ item.umur_baptis }}</td>
									<td>{{ item.pembaptis }}</td>
								</tr>

								<tr v-if="!displayData.length">
									<td colspan="100">
										<p class="text-center p-2">Tidak ada Data</p>
									</td>
								</tr>
							</tbody>
						</v-table>
						<br />
						<smart-pagination
							:currentPage.sync="currentPage"
							:totalPages="totalPages"
							:maxPageLinks="3"
							:boundaryLinks="true"
						/>
					</template>
				</div>
			</div>
		</div>

		<sweet-modal
			modal-theme="light"
			overlay-theme="dark"
			width="80%"
			ref="modalfile"
		>
			<div class="loader-box" v-show="frameLoading">
				<div class="loader-2"></div>
			</div>
			<iframe
				v-show="!frameLoading"
				width="100%"
				:height="windowHeight"
				:src="fileURL"
				frameborder="0"
				allowfullscreen
				@load="load()"
			></iframe>
		</sweet-modal>
	</div>
</template>

<style scoped>
.table tfoot {
	background-color: #212529;
}
.table tfoot td {
	color: #fff;
}

.table {
	font-size: 12px !important;
}

.table th,
.table td {
	padding: 0.5rem;
}
</style>